import { createSlice } from '@reduxjs/toolkit';

const exerciseDataSlice = createSlice({
  name: 'selectedExerciseData',
  initialState: [],
  reducers: {
    setExerciseData: (state, action) => {
      // Modify the draft state instead of returning a new array
      state.splice(0, state.length, ...action.payload);
    },
  },
});

export const { setExerciseData } = exerciseDataSlice.actions;
export default exerciseDataSlice.reducer;